import React from 'react'

import {
  Box,
  Icon,
  IconNames,
  Text,
  FontWeight,
  Display,
  Space,
  Visible,
  JustifyContent,
} from '@gousto-internal/citrus-react'
import { useDispatch } from 'react-redux'

import { RibbonTriggerContainer } from 'components/RibbonTrigger'
import { useIsOptimizelyFeatureEnabled } from 'containers/OptimizelyRollouts'
import { CheckoutButton } from 'routes/Checkout/Components/CheckoutButton'
import { InformationalPageTemplate } from 'routes/Signup/Components/InformationalPageTemplate'
import { StickyCTA } from 'routes/Signup/Components/StickyCTA/StickyCTA'
import { signupGoToCuratedBoxes, signupGoToMenu } from 'routes/Signup/signupActions'

import css from './SellThePropositionPage.css'

type itemsType = {
  key: string
  iconName: IconNames
  className: string
  strongText: string
  normalText: string
}[]
// remove className when PersonaliseMenuStep component is removed
export const items: itemsType = [
  {
    key: 'itemValue',
    iconName: 'offer_pound',
    className: css.itemValue,
    strongText: 'Greater value',
    normalText: 'the more recipes you add',
  },
  {
    key: 'itemRecipes',
    className: css.itemRecipes,
    iconName: 'meals_per_box',
    strongText: 'Over 75 recipes',
    normalText: 'changing weekly',
  },
  {
    key: 'itemSkip',
    className: css.itemSkip,
    iconName: 'skip',
    strongText: 'Choose 2 to 5 recipes',
    normalText: 'or skip a box',
  },
  {
    key: 'itemDietary',
    className: css.itemDietary,
    iconName: 'dietary_preference',
    strongText: 'Meals for every appetite',
    normalText: 'and dietary need',
  },
]

export const SellThePropositionPage = () => {
  const dispatch = useDispatch()
  const ctaText = "See this week's menu"
  const isWizardFloatingCTAEnabled = useIsOptimizelyFeatureEnabled(
    'beetroots_wizard_floating_cta_enabled_v1',
  )
  const isCuratedBoxesV2Enabled = useIsOptimizelyFeatureEnabled(
    'beetroots_is_curated_boxes_v2_enabled',
  )

  const signupRedirect = () =>
    isCuratedBoxesV2Enabled ? signupGoToCuratedBoxes() : signupGoToMenu()

  const renderNonStickyCTA = () => (
    <CheckoutButton
      onClick={() => dispatch(signupRedirect())}
      testingSelector="sellThePropositionNonStickyCTA"
    >
      {ctaText}
    </CheckoutButton>
  )

  const renderStickyCTA = () => (
    <>
      <Visible display={[Display.Block, Display.None]}>
        <StickyCTA
          dataTestId="sellThePropositionStickyCTA"
          onClick={() => dispatch(signupRedirect())}
        >
          {ctaText}
        </StickyCTA>
      </Visible>
      <Visible display={[Display.None, Display.Block]}>
        <Box
          display={[Display.Block, Display.Flex, null]}
          justifyContent={JustifyContent.SpaceBetween}
        >
          {renderNonStickyCTA()}
        </Box>
      </Visible>
    </>
  )

  return (
    <InformationalPageTemplate
      testingSelector="sellThePropositionPage"
      headerText="Get your taste buds ready..."
    >
      <Box>
        {items.map(({ key, iconName, strongText, normalText }) => (
          <Box key={key} display={Display.Flex} paddingBottom={6}>
            <Icon name={iconName} />
            <Space size={2} direction="horizontal" />
            <Text size={2}>
              <Text size={2} fontWeight={FontWeight.Bold} display={Display.Inline}>
                {strongText}&nbsp;
              </Text>
              {normalText}
            </Text>
          </Box>
        ))}
      </Box>
      {isWizardFloatingCTAEnabled ? renderStickyCTA() : renderNonStickyCTA()}
      <RibbonTriggerContainer name="wizard-proposition" />
    </InformationalPageTemplate>
  )
}
